<template>
  <div :class="$style.contactNumbersContent">
    <div :class="$style.contactNumbers">
        <b tabindex="12"
          :class="$style.textContact"
          aria-label="Desde fijos">Desde fijos</b>
      <div :class="$style.divContactImg">
        <img
          :class="$style.img"
          src="~@/assets/images/phone.svg"
          alt="Desde telefonos fijos llama al">
        <span
          tabindex="13"
          aria-label="600 228 7786">600 228 7786</span>
      </div>
    </div>
    <div :class="$style.vLine"></div>
    <div :class="$style.contactNumbersRigth">
        <b
        tabindex="14"
        :class="$style.textContact"
        aria-label="Desde móviles"
        >Desde móviles</b>
      <div :class="$style.divContactImg">
        <img
          :class="$style.img"
          src="~@/assets/images/phone.svg"
          alt="Desde teléfonos moviles llama al">
        <span
          tabindex="15"
          aria-label="22 347 0210"
        >22 347 0210</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'contactNumber',
};
</script>

<style lang="scss" module>

.contactNumbersContent {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;

  & .contactNumbers {
    padding: 24px 32px;
  }

  & .contactNumbersRigth {
    padding: 24px 32px;
  }

  & .textContact {
    padding-bottom: 8px;
  }

  & .divContactImg {
    display: flex;

    & .img {
      padding: 3px 8px 0 0;
      color: black;
    }
  }

  & .vLine {
    height: 48px;
    border: 0.5px solid #c5c6c5;
  }
}

@media (max-width: 990px) {
  .contactNumbersContent {
    display: inline-flex;

    & .contactNumbers {
      width: 190px;
    }

    & .contactNumbersRigth {
      width: 190px;
    }
  }
}

@media (max-width: 430px) {
  .contactNumbersContent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;

    & .contactNumbers {
      justify-content: center;
      width: 190px;
    }

    & .contactNumbersRigth {
      width: 190px;
      padding: 24px 32px;
    }

    & .vLine {
      display: none;
      border: 0.5px solid #c5c6c5;
    }
  }
}
</style>
